import Contact from "../components/Contact";
import About from "../components/About";
import Skills from "../components/Skills";
import Experience from "../components/Experience";
import Education from "../components/Education";
import Projects from "../components/Projects";
import ExitText from "../components/ExitText";
import Footer from "../components/Footer";
import { useState, useEffect } from "react";
import { client } from "../sanity/client";
import "../css/Home.css";
function Home() {
  const [hero, setHero] = useState(null);

  useEffect(() => {
    client.fetch(`*[_type == "hero"][0]`).then((data) => {
      console.log("HERO RAW DATA:", data);
      setHero(data);
    });
  }, []);
  return (
    <>
      <div className="terminal">
        <div className="terminal-header">
          <div id="terminal-dots">
            <span className="dot red"></span>
            <span className="dot yellow"></span>
            <span className="dot green"></span>
          </div>
          <span className="terminal-title">ziad@portfolio:~$</span>
          <a
            //     href="https://docs.google.com/document/d/1JgXVHJTB1gAmeBuHDvxOJnH7xszBUgDF/edit?tab=t.0"
            //     className="resume-btn"
            //     target="_blank"
            //   >
            //     📄 Resume
            href={hero?.resumeUrl}
            className="resume-btn"
            target="_blank"
            rel="noreferrer"
          >
            📄 Resume
          </a>
        </div>

        <div className="terminal-body" id="terminal-body">
          <p id="command-line">
            <span className="prompt">ziad@portfolio:</span>
            <span className="path">~</span>$ <span id="command-text"></span>
            <span className="text">
              {/* Hi, I'm Atique Ahmed Ziad — Full Stack Developer with 8+ years of
              experience. Welcome to my terminal. */}
              {hero?.introText}
            </span>
            <span className="cursor">|</span>
          </p>

          <div id="main-content">
            <br />

            <Contact />
            <About />
            <Skills />
            <Experience />
            <Education />
            <Projects />
            <ExitText />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Home;
